import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

function TodateComponent(props) {
  const toDate = props.toDate;
  const formatToDate = props.formatToDate;
  const DateReverse = props.DateReverse;
  const errorResponse = props.errorResponse;
  const calanderIcon = props.clientWiseReportForCustomCalanderIcon;
 
  return (
    <>
      <div className="form-group calendar-icon">
        <label className="form-label">{Constants.To_Date}<span style={{ color: "red" }}>*</span></label>
        <input
          type="date"
          placeholder="DD/MM/YYYY"
          className="datepicker form-control"
          id="ToDateCombine"
          onChange={toDate}
          defaultValue={formatToDate}
          max={DateReverse}
        />
        <span className="to-date-error">{errorResponse}</span>
        {calanderIcon && <span className="icon-calendar ico"></span>}
      </div>
    </>
  );
}
export default TodateComponent;
